module.exports = __webpack_public_path__ + "img/small.e54a5f17.jpg";